import { ServerStatusResult } from '#hub-check/types';
import { parseWasmResult } from '#wasm/common';
export class UtilsWasm {
    mod;
    constructor(mod) {
        this.mod = mod;
    }
    toLower(str) {
        return parseWasmResult(this.mod.ToLower(str));
    }
    constructBucketName(fsName, fsId) {
        return parseWasmResult(this.mod.ConstructBucketName(fsName, fsId));
    }
    parseServerStatus(serializedVersionInfo, serializedSyncTime) {
        const parsed = parseWasmResult(this.mod.ParseServerStatus(serializedVersionInfo, serializedSyncTime));
        const result = { status: ServerStatusResult.SUCCESS, ...parsed };
        return result;
    }
    deserializeAuxData(buffer) {
        const wasmAuxData = parseWasmResult(this.mod.DeserializeAuxData(buffer));
        return new Map(wasmAuxData.map(({ key, value }) => [key, value]));
    }
    serializeAuxData(auxData, blockSize) {
        const auxFlat = Array.from(auxData).flatMap((e) => e);
        return parseWasmResult(this.mod.SerializeAuxData(auxFlat, blockSize));
    }
    deserializeVersion(buffer) {
        return parseWasmResult(this.mod.DeserializeVersion(buffer));
    }
    normalizePath(path) {
        return parseWasmResult(this.mod.NormalizePath(path));
    }
}
